module.exports = __webpack_public_path__ + "img/certificate.0409d968.png";